"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddSomeValuesButton = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const classnames_1 = __importDefault(require("classnames"));
const add_some_values_button_styles_1 = require("./add-some-values-button.styles");
const multi_select_menu_1 = require("../../../../multi-select-menu");
const localization_1 = require("../../../../../../localization");
// do not pass undefined since it means "select all by default"
const DEFAULT_SELECTED_VALUES = [];
const AddSomeValuesButton = ({ options, title, className, buttonVariant = 'text', iconVariant = 'chevron', isLoading, isDisabled, hasNextPage, moreItemsLoading, isSearching, singleSelect, searchText, onSelect, onCreate, onSearch, onLoadMore, onOpen, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const handleApply = (selected) => {
        onSelect(selected);
        setAnchorEl(null);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(add_some_values_button_styles_1.StyledAction, { rounded: true, variant: buttonVariant, color: "primary", title: title !== null && title !== void 0 ? title : t({ key: 'ADD_VALUES' }), size: "small", disabled: isDisabled, className: (0, classnames_1.default)(className, `action-add--${buttonVariant}`, { 'menu--open': !!anchorEl }), endIcon: iconVariant === 'plus'
            ? react_1.default.createElement(ui_components_1.Icon, { variant: "plus" })
            : react_1.default.createElement(ui_components_1.Icon, { variant: anchorEl ? 'chevronUp' : 'chevronDown' }), onClick: (e) => {
            if (!anchorEl) {
                onOpen === null || onOpen === void 0 ? void 0 : onOpen();
            }
            setAnchorEl(anchorEl ? null : e.currentTarget);
        } }), react_1.default.createElement(multi_select_menu_1.MultiSelectMenu, { anchorEl: anchorEl, isLoading: isLoading, hasNextPage: hasNextPage, defaultSearchText: searchText, moreItemsLoading: moreItemsLoading, isSearching: isSearching, onLoadMore: onLoadMore, onApply: handleApply, selected: DEFAULT_SELECTED_VALUES, singleSelect: singleSelect, strictApply: singleSelect, onClose: () => setAnchorEl(null), onCreate: onCreate, onSearch: onSearch, options: options })));
};
exports.AddSomeValuesButton = AddSomeValuesButton;
exports.default = exports.AddSomeValuesButton;
